<template>
  <div>
  <h4>Dashboard</h4>
  <div class="jumbotron">
    <div class="row">
      <div class="col-lg-4">
        <img id="profile-thumb" v-bind:src="profileImage" alt="Card image cap">
      </div>
      <div class="col-lg-8">
        <h2>{{ getDisplayName }}</h2>
        <h4>{{ getAddress }} {{ getAddressTwo }}<br>{{ getCity }} {{ getState }} {{ getZip }}</h4>
      </div>
      <router-link to="/messaging" v-if="!overdueCouponPayment">
        <i class="to-messaging fa fa-comments" aria-hidden="true"></i>
        <p class="unread-messages">{{ getNotificationNumber }}</p>
      </router-link>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      views: 368,
      quoteRequests: 10,
      couponShares: 43,
      couponViews: 21,
      couponsPurchased: 1
    }
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey',
      'getCognitoId'
    ]),
    ...mapGetters('user', [
      'getNotificationNumber'
    ]),
    ...mapGetters('business', [
      'getDisplayName',
      'getProfileImage',
      'getAddress',
      'getAddressTwo',
      'getCity',
      'getState',
      'getZip',
      'getProfileImageUrl',
      'getCouponPaymentOverdue'
    ]),
    profileImage () {
      if (!this.getProfileImage) return '/static/defaultprofile.png'
      return this.getProfileImageUrl
    },
    overdueCouponPayment () {
      return this.getCouponPaymentOverdue
    }
  }
}
</script>

<style scoped>
.to-messaging {
  position: absolute;
  right: 2rem;
}

.unread-messages {
  position: absolute;
  right: 2.7rem;
  font-size: 1.7rem;
}

#profile-thumb {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover !important;
}

.needs-padding {
  padding-bottom: 1rem;
}

.homapt-numbers {
  color: #748096 !important;
}

th {
  font-size: 1.25rem;
}

td {
  font-size: 3rem;
}

.row {
  padding-bottom: 2rem;
}

.jumbotron {
  background-color:  #f1f1f1  !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.fa-comments {
  font-size: 3rem;
  color: rgb(254, 237, 170);
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/dashboard/Dashboard.vue